import React from "react";

interface VideoSectionProps {
  title: string;
  videoTitle: string;
  videoContent: string;
  videoSrc: string;
}

const VideoSection: React.FC<VideoSectionProps> = ({
  title,
  videoTitle,
  videoContent,
  videoSrc,
}) => {
  const videoContainerStyle: React.CSSProperties = {
    position: "relative",
    width: "100%",
    maxWidth: "640px", // Adjust as needed
    margin: "auto",
  };

  const videoElementStyle: React.CSSProperties = {
    width: "100%",
    height: "auto",
    borderRadius: "30px",
  };

  return (
    <section className="subscription-video-section">
      <div className="subscription-section__heading subscription-section__heading--left">
        <span>{title}</span>
        <h2>{videoTitle}</h2>
        <p>{videoContent}</p>
      </div>
      <div className="subscription-video-card">
                  <div style={videoContainerStyle}>
                    <video style={videoElementStyle} controls>
                      <source src={videoSrc} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </div>
      </div>
    </section>
  );
};

export default VideoSection;
